import { StatusBadge } from "@/components/StatusBadge";
import { CancelDialog } from "@/components/CancelDialog";
import { isPastDate, prettyDate, slotById } from "@/lib/studio";

export const BookingCard = ({ booking, onCancel }) => {
  const canCancel = booking.status === "confirmed" && !isPastDate(booking.date);
  const slot = slotById(booking.slot);
  return (
    <div
      className="surface flex flex-col gap-6 p-6 transition-[border-color] duration-200 hover:border-white/20 md:flex-row md:items-center md:justify-between md:p-8"
      data-testid={`booking-card-${booking.id}`}
    >
      <div className="flex flex-col gap-1">
        <p className="font-display text-xl font-semibold uppercase text-white">{prettyDate(booking.date)}</p>
        <p className="font-tech text-sm text-zinc-300">{slot?.label} · {slot?.time}</p>
        <p className="text-sm text-zinc-500">{booking.space || "No space preference"}</p>
        {booking.notes && <p className="mt-2 max-w-lg text-sm text-zinc-400">“{booking.notes}”</p>}
      </div>
      <div className="flex items-center gap-4">
        <StatusBadge status={booking.status} testId={`booking-status-${booking.id}`} />
        {canCancel && (
          <CancelDialog
            testId={`cancel-booking-${booking.id}`}
            description={`${prettyDate(booking.date)}, ${slot?.time}. The slot will be released for others.`}
            onConfirm={() => onCancel(booking.id)}
          >
            <button className="btn-ghost-riot !px-4 !py-2 text-xs" data-testid={`cancel-booking-btn-${booking.id}`}>Cancel</button>
          </CancelDialog>
        )}
      </div>
    </div>
  );
};
